import api from "../../../../services/api";
import { getStoredSimulations, addToStoredSimulations } from "../../helpers";

export const getZoneValidationError = (selectedZone) => {
  if (!selectedZone) {
    return "You must select a zone";
  }
  if (!selectedZone.destinationId) {
    return "Zone does not have a destination ID";
  }
};

const generateOrderIdPrefix = () => {
  const ALLOWED_CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const characterArray = ALLOWED_CHARACTERS.split("");
  let orderPrefix = "";
  for (let i = 0; i < 3; i++) {
    const targetCharacterIndex = Math.floor(
      Math.random() * ALLOWED_CHARACTERS.length
    );
    orderPrefix += characterArray[targetCharacterIndex];
  }
  return orderPrefix;
};

export const simulateNewOrder = async (
  project,
  zone,
  customerName,
  carMake,
  carPlate,
  startDistance,
  intervalTime,
  intervalDistance
) => {
  const storedOrders = getStoredSimulations();
  let orderNumber = 1;
  let orderPrefix = generateOrderIdPrefix();
  if (storedOrders.length) {
    const latestOrder = storedOrders[storedOrders.length - 1];
    const latestOrderPrefix = latestOrder.orderId.substring(0, 3);
    orderPrefix = latestOrderPrefix;
    const latestOrderNumber = parseInt(latestOrder.orderId.substring(3), 10);
    orderNumber = latestOrderNumber + 1;
  }
  const orderString = orderPrefix + String(orderNumber).padStart(6, "0");

  try {
    const startOmsSimulatorResponse = api.createOmsSimulatorOrder(
      orderString,
      customerName
    );
    const startTempoSimulatorResponse = api.createTempoSimulatorOrder(
      project._id,
      zone._id,
      zone.destinationId,
      orderString,
      customerName,
      carMake,
      carPlate,
      startDistance,
      intervalTime,
      intervalDistance
    );
    await startOmsSimulatorResponse;
    await startTempoSimulatorResponse;
    addToStoredSimulations(
      project,
      zone,
      customerName,
      carMake,
      carPlate,
      orderString,
      startDistance,
      intervalTime,
      intervalDistance
    );
  } catch (error) {
    console.log(error);
    alert("an error occurred creating simulations");
  }
};
